import { render, staticRenderFns } from "./TipoConsultaAltaDigital.vue?vue&type=template&id=785053ed&scoped=true"
import script from "./TipoConsultaAltaDigital.vue?vue&type=script&lang=js"
export * from "./TipoConsultaAltaDigital.vue?vue&type=script&lang=js"
import style0 from "./TipoConsultaAltaDigital.vue?vue&type=style&index=0&id=785053ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785053ed",
  null
  
)

export default component.exports